module.exports = {
  title: '平台收入明细',
  route: {
    path: '/finance-manage',
    children: {
      path: 'platform-income-detail',
    },
  },
};
